// extracted by mini-css-extract-plugin
export default {"list":"TasksList_list__kjKiH"};